export const Tabs = [

    {
        title: 'Contribute',
        route: '/collection',
    },
    {
        title: 'Transaction history',
        route: '/collection/transactionHistory'
    },
]


